<template>
  <div style="width: 100%;">
    <el-row v-if="syncedValue && syncedValue.length" v-bind="rowProps">
      <el-col v-for="(item, index) in syncedValue" :key="ensureKey(item, index)" v-bind="colProps">
        <div class="input-group">
          <div class="input-group-content">
            <slot :value="item" :index="index">
              <el-input v-model="syncedValue[index]" :placeholder="placeholder" v-bind="inputProps" />
            </slot>
          </div>
          <el-button-group class="btn-group">
            <el-button
              round
              :icon="plusIcon"
              :disabled="max ? syncedValue.length >= max : false"
              @click="onAdd(index)"
            />
            <el-button
              round
              :icon="deleteIcon"
              :disabled="min ? syncedValue.length <= min : false"
              @click="onDelete(index)"
            />
          </el-button-group>
        </div>
      </el-col>
    </el-row>
    <el-button
      v-else
      class="btn-add-block"
      :icon="plusIcon"
      @click="onAdd()"
    />
  </div>
</template>

<script>
import { Vue, Component, Prop, Watch, PropSync } from 'vue-property-decorator'
import _ from 'lodash'

@Component
export default class DynamicInputs extends Vue {
  @PropSync('value', { type: Array, required: true }) syncedValue

  @Prop({ type: Number, default: 0 }) min
  @Prop({ type: Number }) max
  @Prop(String) placeholder
  @Prop({
    type: Object,
    default: () => ({ gutter: 20 })
  }) rowProps

  @Prop({
    type: Object,
    default: () => ({})
  }) colProps

  @Prop(Object) inputProps
  @Prop(Function) onCreate
  @Prop({ type: String, default: 'id' }) keyField

  plusIcon = 'el-icon-plus'
  deleteIcon = 'el-icon-delete'

  ensureKey(value, index) {
    return _.get(value, this.keyField) || index;
  }

  @Watch('syncedValue', { immediate: true })
  onValueChange() {
    if (!this.syncedValue) {
      this.syncedValue = []
      return
    }
    if (this.min && this.syncedValue.length < this.min) {
      this.syncedValue.push(...new Array(this.min - this.syncedValue.length).fill('').map((i, idx) => this.getNewItem(idx)))
    }
  }

  getNewItem(index = 0) {
    return this.onCreate ? this.onCreate(index) : '';
  }

  onAdd(index) {
    const newItem = this.getNewItem(index);

    if (typeof index === 'number') {
      this.syncedValue.splice(index + 1, 0, newItem)
    } else {
      this.syncedValue.push(newItem)
    }
  }

  onDelete(index) {
    this.syncedValue.splice(index, 1)
  }
}
</script>

<style lang="scss" scoped>
.btn-add-block {
  width: 100%;
}

.input-group {
  display: flex;
  width: 100%;
  gap: 10px;
  margin-bottom: 10px;

  .input-group-content {
    flex: 1;
  }

  .btn-group {
    flex-shrink: 0;
  }
}
</style>
